fragment LeadSummaryFragment on Lead {
    id
    status
    number
    territory
    createdTime
    confidence
    closedTime
    anticipatedClosedTime
    creator {
        id
        name
    }
    clonedFrom {
        id
        number
        htmlUrl
    }
    outcome {
        id
        name
    }
}
